import { selectBuildingsCategoryMap } from "../../../balancingSelectors/selectBalancingUiDefinitions";
export var selectBuildingCategoryType = function (state, buildingId) {
    var buildingCategoryMap = selectBuildingsCategoryMap();
    for (var _i = 0, _a = Object.keys(buildingCategoryMap); _i < _a.length; _i++) {
        var categoryId = _a[_i];
        var isBuildingPresent = buildingCategoryMap[categoryId].includes(buildingId);
        if (isBuildingPresent) {
            return categoryId;
        }
    }
    return undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/selectors/selectBuildingCategoryType.ts
// module id = 829
// module chunks = 3